// extracted by mini-css-extract-plugin
export default {"sub-title":"styles_sub-title__TVyAm","row":"styles_row__PFuQM","label":"styles_label__2odZH"};